var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFoldedMap = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.332031 2.33398L4.9987 0.333984L8.9987 2.33398L13.2007 0.533318C13.2514 0.511573 13.3068 0.502764 13.3617 0.507679C13.4167 0.512595 13.4696 0.531082 13.5156 0.561481C13.5617 0.59188 13.5995 0.63324 13.6256 0.68185C13.6518 0.730459 13.6654 0.784796 13.6654 0.839984V11.6673L8.9987 13.6673L4.9987 11.6673L0.796698 13.468C0.745974 13.4897 0.690644 13.4985 0.635675 13.4936C0.580706 13.4887 0.527817 13.4702 0.481756 13.4398C0.435695 13.4094 0.397902 13.3681 0.371769 13.3195C0.345637 13.2708 0.331982 13.2165 0.332031 13.1613V2.33398ZM8.9987 12.1767V3.78465L8.95536 3.80332L4.9987 1.82465V10.2167L5.04203 10.198L8.9987 12.1767Z",
    fill: "#19305A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFoldedMap, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/foldedMap.6d1b5c1d.svg";
export { ForwardRef as ReactComponent };